import { Autocomplete, Box, Card, CardContent, CardHeader, CircularProgress, Container, Grid, Pagination, TextField, Typography } from "@mui/material";
import IresearhService from "../../services/IresearchService";
import { useEffect, useState } from "react";
import { InvestigadorBusqueda } from "../../Interface/IInvestigadorUnidad";
import { Publicacion } from "../../Interface/IPublicacionOds";
import { Link, useNavigate } from "react-router-dom";



export const BusquedaAutor: React.FC = () => {
    const [investigadores, setInvestigadores] = useState<InvestigadorBusqueda[]>([]);
    const [scopusId, setScopusId] = useState<string | null>(null);
    const [publicaciones, setPublicaciones] = useState<Publicacion[]>([]);
    const [loading, setLoading] = useState(false);
    const [noresults, setNoresults] = useState(false);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const navigate = useNavigate();



    useEffect(() => {
        IresearhService.GetAutores()
            .then((response) => {
                const info: InvestigadorBusqueda[] = response.listData;
                setInvestigadores(info)
            });
    }, []);

    useEffect(() => {
        if (scopusId) {
            obtenerPublicaciones(1)
        } else {
            setPublicaciones([])
            setTotalPages(0)
            setPage(1)

        }
    }, [scopusId]);

    const normalize = (str: string): string =>
            str
            .toLowerCase()
            .normalize("NFD") 
            .replace(/[\u0300-\u036f]/g, ""); 

    const customFilterOptions = ( options: InvestigadorBusqueda[], { inputValue }: { inputValue: string }): InvestigadorBusqueda[] => {
        const searchTerms = normalize(inputValue).split(" ").filter(Boolean);
        return options.filter((option) => {
            const nombre = normalize(option.nombre);
            return searchTerms.every((term) => nombre.includes(term));
        });
    };

    const obtenerPublicaciones = (pageNumber: number) => {
        if (scopusId) {
            setLoading(true);
            IresearhService.GetMyPublicationsByScopusId(scopusId, pageNumber)
                .then((pub) => {
                    if (pub.data.totalCount === 0) {
                        setNoresults(true);
                    } else {
                        setPublicaciones(pub.data.data);
                        setTotalPages(pub.data.totalPages);
                        setNoresults(false);
                    }
                })
                .catch((error) => console.error("Error fetching publications:", error))
                .finally(() => {
                    setLoading(false);
                });
        }
    };




    const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        obtenerPublicaciones(value);
    };

    return (
        <Container maxWidth="lg" style={{ padding: "20px", textAlign: "center" }}>
            <Grid container justifyContent="center">
                <Grid item xs={12} sm={10} md={8}>
                    <Autocomplete
                        options={investigadores}
                        getOptionLabel={(option) => option.nombre}
                        filterOptions={customFilterOptions}
                        /* onChange={(_, value) => setScopusId(value ? value.scopusId : null)}*/
                        onChange={(_, value) => {
                            if (value) {
                                navigate(`/investigador/${value.scopusId}`);
                            }
                        }}
                        renderInput={(params) => <TextField {...params} label="Buscar Investigador" />}
                    />
                    {/*{scopusId && <p>Scopus ID seleccionado: {scopusId}</p>}*/}
                </Grid>
            </Grid>


            {loading ? (
                <CircularProgress sx={{ marginTop: 3 }} />
            ) : noresults ? (
                <Typography variant="h6" color="textSecondary" sx={{ marginTop: 3 }}>
                    No se encontraron resultados.
                </Typography>
            ) : (
                <>
                    <Box sx={{ marginTop: "20px", paddingTop: "20px", paddingBottom: "20px", boxShadow: publicaciones.length > 0 ? 2 : 0 }}>
                        <Grid container justifyContent="center" alignItems="center">
                            <Grid item xs={12} sm={10} md={10} container spacing={8} justifyContent="center">
                                {publicaciones.map((item) => {
                                    const publicacion_url = `/publicacion/${item.eid}`;
                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={item.doi}>
                                            <Link to={publicacion_url} style={{ textDecoration: 'none' }}>
                                                <Card sx={{ width: '100%', height: 200, display: 'flex', flexDirection: 'column' }}>
                                                    <CardHeader sx={{ backgroundColor: "blue", color: "white", height: 40 }} title="Publicación" />
                                                    <CardContent sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <Typography variant="body1" align="center">
                                                            {item.title}
                                                        </Typography>
                                                    </CardContent>
                                                </Card>
                                            </Link>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    </Box>

                    {totalPages > 1  && (
                        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                color="primary"
                            />
                        </Box>
                    )}
                </>
            )}
        </Container>
    );
};